module.exports = __webpack_public_path__ + "assets/images/esfera_a3897cf0ad2a5b0ef17a050e0d5cbf89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/esfera/esfera.png
// module id = 201
// module chunks = 0